import { articles } from '@/mocks/articles';

const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

export default function FeaturedArticles() {
  return (
    <section id="featured" className="py-16 md:py-24 px-4 md:px-6 bg-background-50" aria-labelledby="featured-title">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-14">
          <div>
            <p className="text-xs md:text-sm text-primary-500 font-semibold tracking-[0.2em] uppercase mb-3">
              精选文章
            </p>
            <h2 id="featured-title" className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              开启你的行动力之旅
            </h2>
          </div>
          <Link
            to="/category/action-methodology"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-lg border border-background-200/80 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line w-3 h-3 flex items-center justify-center"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {article.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}